module.exports = __webpack_public_path__ + "media/3_17.dbc75d35.wav";